export const EQL_QUERIES = ['^executeEQL', '^batchExecuteEQL'].join('|');
export const SELECT_RECORDS = '^((?!select records).)*$';

export const FOF_DELAY = 3500;

export enum FeedbackListViewType {
  DEFAULT = 'DEFAULT',
  SAVED = 'SAVED',
  SAMPLE = 'SAMPLE',
}

export const RECORDS_PER_PAGE = 10; // Number of feedbacks fetched per page, depends on BE, FE can't change it

export const PREFETCH_TRIGGER_OFFSET = 6; // Number of feedbacks before the end of the list to prefetch the next page

export const SHOULD_SHOW_FEEDBACK_LIST_SUMMARY_VIEW =
  'shouldShowFeedbackListSummaryView';

export const FEEDBACK_MESSAGE_ACTOR_ID_FALLBACK = 'Unknown user';
